import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import { Result } from 'antd';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { ReactComponent as NotFoundSvg } from 'assets/svgs/404.svg';
import { Page as PageAtom } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';
import { useDismissBootSkeleton } from 'utils/dismiss-boot-skeleton';
const Page = styled(PageAtom)`
  justify-content: center;
`;
export const NotFound = ()=>{
    useDismissBootSkeleton();
    return /*#__PURE__*/ _jsxs(Page, {
        $gray: true,
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    "data-cy": "page.not.found.title",
                    children: useTranslation('error.404.title')
                })
            }),
            /*#__PURE__*/ _jsx(Result, {
                title: useTranslation('error.404.title'),
                icon: /*#__PURE__*/ _jsx(NotFoundSvg, {}),
                subTitle: useTranslation('error.404.message'),
                extra: /*#__PURE__*/ _jsx(Link, {
                    to: "/",
                    type: "primary",
                    children: useTranslation('error.404.action')
                })
            })
        ]
    });
};
